<template>
  <div class="container">
    <ul class="flex" style="flex-wrap:wrap;">
      <li v-for="item in list" :key="item.id" class="list-item mr-20 mb-20">
        <Link :to="item.url" class="img-link" target="_blank" :title="item.title">
          <img :alt="item.title" :src="item.adImage||require('@/assets/images/home/default.jpg')" @error="handleImageError($event)">
          <div class="txt flex-center">
            <p class="el-2" :title="item.title">{{ item.title }}</p>
          </div>
        </Link>
      </li>
    </ul>
    <info-pagination
      :total="total"
      :current-page.sync="curPage"
      :page-size="pageSize"
      @current-change="loadListData"
    />
  </div>
</template>

<script>
import adApi from "@/api/ad";
import InfoPagination from "@/components/InfoPagination.vue";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";

export default {
  name: "AdvertList",
  components: { Link, InfoPagination },
  props: {
  },
  data() {
    return {
      curPage: 1,
      pageSize: 16,
      total: 0,
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loadListData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    handleImageError(event) {
      console.log("图片加载失败，使用默认图片");
      event.target.src = require("@/assets/images/home/default.jpg"); // 替换为本地图片路径
    },
    loadListData() {
      adApi.page({
        pageNo: this.curPage,
        pageSize: this.pageSize,
        type: this.$route.params.code
      }).then((res) => {
        const data = res.data || {}
        this.list = data.list || []
        this.total = data.total
      });
    }
  }
};
</script>

<style scoped lang="scss">
.list-item{
	width: 285px;
	border: 1px solid #ddd;
  flex-shrink: 0;
	&:nth-of-type(4n){
		margin-right: 0;
	}
	img{
		width: 100%;
		height: 200px;
		vertical-align: middle;
		display: block;
	}
	.txt{
		width: 100%;
		height: 60px;
		border-top: 1px solid #ddd;
		padding: 10px;
		p{
			width: 100%;
			color: #333;
			font-size: 14px;
			line-height: 18px;
		}
	}
	&:hover{
		opacity: 0.8;
		p{
			color: $--color-primary;
		}
	}
}
</style>
